import { Link as MuiLink } from "@mui/material";
import React from "react";
import useObservedText from "../../Hooks/useObservedText";
import { LinkModel } from "../../Models/LinkModel";
import IComponentProps from "../IComponentProps";
import getComponentLayout from "../Table/getComponentLayout";

const LinkComponent: React.FC<IComponentProps<LinkModel>> = ({ component, context }) => {
  const componentLayoutSx = getComponentLayout(component);

  const href = useObservedText(component.HrefTemplate, context, "LinkComponent");

  if (!href) {
    return null;
  }

  return (
    <MuiLink href={href} variant={component.Variant} target={component.Target} sx={{ ...componentLayoutSx, textDecoration: "none" }}>
      {component.Text}
    </MuiLink>
  );
};

export default LinkComponent;
